// Expressão regular para validar o nome completo (apenas letras, espaços e caracteres acentuados)
export const validateFullName = (fullName) => {
  // A regex agora permite letras acentuadas e espaços, mas não permite espaços extras no início ou fim.
  const nameRegex = /^[a-zA-ZÀ-ÿ\s]+$/;  // Permite letras acentuadas (incluindo letras com acentos, ç, etc.)
  if (!fullName.trim() || !nameRegex.test(fullName)) {  // Garante que o nome não esteja vazio ou contenha apenas espaços
    return 'Por favor, insira um nome válido.';
  }
  return '';
};

// Expressão regular para validar o email
export const validateEmail = (email) => {
  // A regex agora aceita domínios mais longos e permite caracteres especiais em locais corretos
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!emailRegex.test(email)) {
    return 'Por favor, insira um email válido.';
  }
  return '';
};

// Expressão regular para validar a senha (mínimo de 8 caracteres, inclui letras, números e caracteres especiais)
export const validatePassword = (password) => {
  // A regex agora exige pelo menos uma letra, um número e um caractere especial
  const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+=[\]{};:'",.<>?/\\|`~^&*-]).{8,}$/;
  if (!passwordRegex.test(password)) {
    return 'A senha deve ter pelo menos 8 caracteres, incluindo letras, números e caracteres especiais.';
  }
  return '';
};
